webpackJsonp([35783957827783],{

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(66);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(98);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(97);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _objectWithoutProperties2 = __webpack_require__(172);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(171);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Handle legacy names for image queries.
	var convertProps = function convertProps(props) {
	  var convertedProps = (0, _extends3.default)({}, props);
	  if (convertedProps.responsiveResolution) {
	    convertedProps.resolutions = convertedProps.responsiveResolution;
	    delete convertedProps.responsiveResolution;
	  }
	  if (convertedProps.responsiveSizes) {
	    convertedProps.sizes = convertedProps.responsiveSizes;
	    delete convertedProps.responsiveSizes;
	  }
	
	  return convertedProps;
	};
	
	// Cache if we've seen an image before so we don't both with
	// lazy-loading & fading in on subsequent mounts.
	var imageCache = {};
	var inImageCache = function inImageCache(props) {
	  var convertedProps = convertProps(props);
	  // Find src
	  var src = convertedProps.sizes ? convertedProps.sizes.src : convertedProps.resolutions.src;
	
	  if (imageCache[src]) {
	    return true;
	  } else {
	    imageCache[src] = true;
	    return false;
	  }
	};
	
	var io = void 0;
	var listeners = [];
	
	function getIO() {
	  if (typeof io === "undefined" && typeof window !== "undefined" && window.IntersectionObserver) {
	    io = new window.IntersectionObserver(function (entries) {
	      entries.forEach(function (entry) {
	        listeners.forEach(function (l) {
	          if (l[0] === entry.target) {
	            // Edge doesn't currently support isIntersecting, so also test for an intersectionRatio > 0
	            if (entry.isIntersecting || entry.intersectionRatio > 0) {
	              io.unobserve(l[0]);
	              l[1]();
	            }
	          }
	        });
	      });
	    }, { rootMargin: "200px" });
	  }
	
	  return io;
	}
	
	var listenToIntersections = function listenToIntersections(el, cb) {
	  getIO().observe(el);
	  listeners.push([el, cb]);
	};
	
	var isWebpSupportedCache = null;
	var isWebpSupported = function isWebpSupported() {
	  if (isWebpSupportedCache !== null) {
	    return isWebpSupportedCache;
	  }
	
	  var elem = typeof window !== "undefined" ? window.document.createElement("canvas") : {};
	  if (elem.getContext && elem.getContext("2d")) {
	    isWebpSupportedCache = elem.toDataURL("image/webp").indexOf("data:image/webp") === 0;
	  } else {
	    isWebpSupportedCache = false;
	  }
	
	  return isWebpSupportedCache;
	};
	
	var noscriptImg = function noscriptImg(props) {
	  // Check if prop exists before adding each attribute to the string output below to prevent
	  // HTML validation issues caused by empty values like width="" and height=""
	  var src = props.src ? "src=\"" + props.src + "\" " : "src=\"\" "; // required attribute
	  var srcSet = props.srcSet ? "srcset=\"" + props.srcSet + "\" " : "";
	  var sizes = props.sizes ? "sizes=\"" + props.sizes + "\" " : "";
	  var title = props.title ? "title=\"" + props.title + "\" " : "";
	  var alt = props.alt ? "alt=\"" + props.alt + "\" " : "alt=\"\" "; // required attribute
	  var width = props.width ? "width=\"" + props.width + "\" " : "";
	  var height = props.height ? "height=\"" + props.height + "\" " : "";
	  var opacity = props.opacity ? props.opacity : "1";
	  var transitionDelay = props.transitionDelay ? props.transitionDelay : "0.5s";
	
	  return "<img " + width + height + src + srcSet + alt + title + sizes + "style=\"position:absolute;top:0;left:0;transition:opacity 0.5s;transition-delay:" + transitionDelay + ";opacity:" + opacity + ";width:100%;height:100%;object-fit:cover;object-position:center\"/>";
	};
	
	var Img = function Img(props) {
	  var style = props.style,
	      onLoad = props.onLoad,
	      otherProps = (0, _objectWithoutProperties3.default)(props, ["style", "onLoad"]);
	
	  return _react2.default.createElement("img", (0, _extends3.default)({}, otherProps, {
	    onLoad: onLoad,
	    style: (0, _extends3.default)({
	      position: "absolute",
	      top: 0,
	      left: 0,
	      transition: "opacity 0.5s",
	      width: "100%",
	      height: "100%",
	      objectFit: "cover",
	      objectPosition: "center"
	    }, style)
	  }));
	};
	
	Img.propTypes = {
	  style: _propTypes2.default.object,
	  onLoad: _propTypes2.default.func
	};
	
	var Image = function (_React$Component) {
	  (0, _inherits3.default)(Image, _React$Component);
	
	  function Image(props) {
	    (0, _classCallCheck3.default)(this, Image);
	
	    // If this browser doesn't support the IntersectionObserver API
	    // we default to start downloading the image right away.
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));
	
	    var isVisible = true;
	    var imgLoaded = true;
	    var IOSupported = false;
	
	    // If this image has already been loaded before then we can assume it's
	    // already in the browser cache so it's cheap to just show directly.
	    var seenBefore = inImageCache(props);
	
	    if (!seenBefore && typeof window !== "undefined" && window.IntersectionObserver) {
	      isVisible = false;
	      imgLoaded = false;
	      IOSupported = true;
	    }
	
	    // Always don't render image while server rendering
	    if (typeof window === "undefined") {
	      isVisible = false;
	      imgLoaded = false;
	    }
	
	    _this.state = {
	      isVisible: isVisible,
	      imgLoaded: imgLoaded,
	      IOSupported: IOSupported
	    };
	
	    _this.handleRef = _this.handleRef.bind(_this);
	    return _this;
	  }
	
	  Image.prototype.handleRef = function handleRef(ref) {
	    var _this2 = this;
	
	    if (this.state.IOSupported && ref) {
	      listenToIntersections(ref, function () {
	        _this2.setState({ isVisible: true, imgLoaded: false });
	      });
	    }
	  };
	
	  Image.prototype.render = function render() {
	    var _this3 = this;
	
	    var _convertProps = convertProps(this.props),
	        title = _convertProps.title,
	        alt = _convertProps.alt,
	        className = _convertProps.className,
	        outerWrapperClassName = _convertProps.outerWrapperClassName,
	        _convertProps$style = _convertProps.style,
	        style = _convertProps$style === undefined ? {} : _convertProps$style,
	        _convertProps$imgStyl = _convertProps.imgStyle,
	        imgStyle = _convertProps$imgStyl === undefined ? {} : _convertProps$imgStyl,
	        _convertProps$placeho = _convertProps.placeholderStyle,
	        placeholderStyle = _convertProps$placeho === undefined ? {} : _convertProps$placeho,
	        sizes = _convertProps.sizes,
	        resolutions = _convertProps.resolutions,
	        backgroundColor = _convertProps.backgroundColor,
	        Tag = _convertProps.Tag;
	
	    var bgColor = void 0;
	    if (typeof backgroundColor === "boolean") {
	      bgColor = "lightgray";
	    } else {
	      bgColor = backgroundColor;
	    }
	
	    var imagePlaceholderStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded ? 0 : 1,
	      transitionDelay: "0.25s"
	    }, imgStyle, placeholderStyle);
	
	    var imageStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded || this.props.fadeIn === false ? 1 : 0
	    }, imgStyle);
	
	    if (sizes) {
	      var image = sizes;
	
	      // Use webp by default if browser supports it
	      if (image.srcWebp && image.srcSetWebp && isWebpSupported()) {
	        image.src = image.srcWebp;
	        image.srcSet = image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: (0, _extends3.default)({
	              position: "relative",
	              overflow: "hidden"
	            }, style),
	            ref: this.handleRef
	          },
	          _react2.default.createElement(Tag, {
	            style: {
	              width: "100%",
	              paddingBottom: 100 / image.aspectRatio + "%"
	            }
	          }),
	          image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.base64,
	            style: imagePlaceholderStyle
	          }),
	          image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              position: "absolute",
	              top: 0,
	              bottom: 0,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.35s",
	              right: 0,
	              left: 0
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            srcSet: image.srcSet,
	            src: image.src,
	            sizes: image.sizes,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.state.IOSupported && _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({ alt: alt, title: title }, image))
	            }
	          })
	        )
	      );
	    }
	
	    if (resolutions) {
	      var _image = resolutions;
	      var divStyle = (0, _extends3.default)({
	        position: "relative",
	        overflow: "hidden",
	        display: "inline-block",
	        width: _image.width,
	        height: _image.height
	      }, style);
	
	      if (style.display === "inherit") {
	        delete divStyle.display;
	      }
	
	      // Use webp by default if browser supports it
	      if (_image.srcWebp && _image.srcSetWebp && isWebpSupported()) {
	        _image.src = _image.srcWebp;
	        _image.srcSet = _image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: divStyle,
	            ref: this.handleRef
	          },
	          _image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.base64,
	            style: imagePlaceholderStyle
	          }),
	          _image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              width: _image.width,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.25s",
	              height: _image.height
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            width: _image.width,
	            height: _image.height,
	            srcSet: _image.srcSet,
	            src: _image.src,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({
	                alt: alt,
	                title: title,
	                width: _image.width,
	                height: _image.height
	              }, _image))
	            }
	          })
	        )
	      );
	    }
	
	    return null;
	  };
	
	  return Image;
	}(_react2.default.Component);
	
	Image.defaultProps = {
	  fadeIn: true,
	  alt: "",
	  Tag: "div"
	};
	
	Image.propTypes = {
	  responsiveResolution: _propTypes2.default.object,
	  responsiveSizes: _propTypes2.default.object,
	  resolutions: _propTypes2.default.object,
	  sizes: _propTypes2.default.object,
	  fadeIn: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  alt: _propTypes2.default.string,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]), // Support Glamor's css prop.
	  outerWrapperClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  style: _propTypes2.default.object,
	  imgStyle: _propTypes2.default.object,
	  placeholderStyle: _propTypes2.default.object,
	  position: _propTypes2.default.string,
	  backgroundColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
	  onLoad: _propTypes2.default.func,
	  Tag: _propTypes2.default.string
	};
	
	exports.default = Image;

/***/ }),

/***/ 96:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(25);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _styledSystem = __webpack_require__(55);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// this component basically exists as a giant stylesheet that inherits from the theme
	// it's for markdown content (hence the name)
	// it's kind of a b
	var MarkdownContent = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'ezw9sfq0'
	})(_styledSystem.space, ';', _styledSystem.fontSize, ';', _styledSystem.color, ';', _styledSystem.fontFamily, ';', _styledSystem.lineHeight, ';& > *{margin-top:0;margin-bottom:0;width:100%;& + *{margin-top:', function (_ref) {
	  var theme = _ref.theme;
	  return theme.space[3];
	}, ';}& + h1,& + h2{margin-top:', function (_ref2) {
	  var theme = _ref2.theme;
	  return theme.space[5];
	}, ';}& + h3,& + h4{margin-top:', function (_ref3) {
	  var theme = _ref3.theme;
	  return theme.space[4];
	}, ';}}h1,h2,h3,h4,h5,h6{line-height:', function (_ref4) {
	  var theme = _ref4.theme;
	  return theme.lineHeights.title;
	}, ';}p,ul,ol,address{}h1{font-size:', function (_ref5) {
	  var theme = _ref5.theme;
	  return theme.fontSizes[3];
	}, ';font-weight:600;@media (min-width:', function (_ref6) {
	  var theme = _ref6.theme;
	  return theme.breakpoints[0];
	}, '){font-size:', function (_ref7) {
	  var theme = _ref7.theme;
	  return theme.fontSizes[4];
	}, ';}}h2{font-size:', function (_ref8) {
	  var theme = _ref8.theme;
	  return theme.fontSizes[2];
	}, ';font-weight:600;@media (min-width:', function (_ref9) {
	  var theme = _ref9.theme;
	  return theme.breakpoints[0];
	}, '){font-size:', function (_ref10) {
	  var theme = _ref10.theme;
	  return theme.fontSizes[3];
	}, ';}}h3{font-size:', function (_ref11) {
	  var theme = _ref11.theme;
	  return theme.fontSizes[1];
	}, ';font-weight:600;@media (min-width:', function (_ref12) {
	  var theme = _ref12.theme;
	  return theme.breakpoints[0];
	}, '){font-size:', function (_ref13) {
	  var theme = _ref13.theme;
	  return theme.fontSizes[2];
	}, ';}}h4,h5,h6{font-size:', function (_ref14) {
	  var theme = _ref14.theme;
	  return theme.fontSizes[1];
	}, ';font-weight:500;@media (min-width:', function (_ref15) {
	  var theme = _ref15.theme;
	  return theme.breakpoints[0];
	}, '){font-size:', function (_ref16) {
	  var theme = _ref16.theme;
	  return theme.fontSizes[2];
	}, ';}}hr{width:100%;max-width:4rem;margin-left:0;margin-right:0;border:', function (_ref17) {
	  var theme = _ref17.theme;
	  return theme.borders[1];
	}, ' ', function (_ref18) {
	  var theme = _ref18.theme;
	  return theme.colors.orange;
	}, ';margin:', function (_ref19) {
	  var theme = _ref19.theme;
	  return theme.space[4];
	}, ' 0;}ul,ol{padding-left:', function (_ref20) {
	  var theme = _ref20.theme;
	  return theme.space[4];
	}, ';}ul ul,ol ol,ul ol,ol ul{margin-top:0;margin-bottom:0;}b,strong,em,small,code{line-height:1;}sup,sub{vertical-align:baseline;position:relative;top:-0.4em;}sub{top:0.4em;}a{color:', function (_ref21) {
	  var theme = _ref21.theme;
	  return theme.colors.black;
	}, ';text-decoration:underline;text-decoration-color:', function (_ref22) {
	  var theme = _ref22.theme;
	  return theme.colors.orange;
	}, ';&:hover{color:', function (_ref23) {
	  var theme = _ref23.theme;
	  return theme.colors.orange;
	}, ';}@media print{&:after{content:\' (\' attr(href) \')\';font-size:0.875em;}&[href^=\'/\']:after{content:\' (https://lukas.pustina.de\' attr(href) \')\';}}}blockquote{margin-top:', function (_ref24) {
	  var theme = _ref24.theme;
	  return theme.space[3];
	}, ';margin-right:0;margin-bottom:', function (_ref25) {
	  var theme = _ref25.theme;
	  return theme.space[3];
	}, ';margin-left:0;border-left:', function (_ref26) {
	  var theme = _ref26.theme;
	  return theme.borders[1];
	}, ' ', function (_ref27) {
	  var theme = _ref27.theme;
	  return theme.colors.orange;
	}, ';border-radius:', function (_ref28) {
	  var theme = _ref28.theme;
	  return theme.radii[1];
	}, ';padding:', function (_ref29) {
	  var theme = _ref29.theme;
	  return theme.space[2];
	}, ';background-color:', function (_ref30) {
	  var theme = _ref30.theme;
	  return theme.colors.nearWhite;
	}, ';p{}>:first-child{margin-top:0;}>:last-child{margin-bottom:0;}}code{font-family:', function (_ref31) {
	  var theme = _ref31.theme;
	  return theme.fonts.monospace;
	}, ';}p code,li code{border:1px solid rgba(0,0,0,0.1);border-radius:', function (_ref32) {
	  var theme = _ref32.theme;
	  return theme.radii[1];
	}, ';padding-left:', function (_ref33) {
	  var theme = _ref33.theme;
	  return theme.space[1];
	}, ';padding-right:', function (_ref34) {
	  var theme = _ref34.theme;
	  return theme.space[1];
	}, ';background-color:', function (_ref35) {
	  var theme = _ref35.theme;
	  return theme.colors.nearWhite;
	}, ';font-size:', function (_ref36) {
	  var theme = _ref36.theme;
	  return theme.fontSizes[0];
	}, ';white-space:nowrap;@media (min-width:', function (_ref37) {
	  var theme = _ref37.theme;
	  return theme.breakpoints[0];
	}, '){font-size:', function (_ref38) {
	  var theme = _ref38.theme;
	  return theme.fontSizes[1];
	}, ';}}pre{width:100%;overflow-x:scroll;margin-top:', function (_ref39) {
	  var theme = _ref39.theme;
	  return theme.space[4];
	}, ';margin-bottom:', function (_ref40) {
	  var theme = _ref40.theme;
	  return theme.space[4];
	}, ';border-left:', function (_ref41) {
	  var theme = _ref41.theme;
	  return theme.borders[1];
	}, ' ', function (_ref42) {
	  var theme = _ref42.theme;
	  return theme.colors.nearWhite;
	}, ';border-radius:', function (_ref43) {
	  var theme = _ref43.theme;
	  return theme.radii[1];
	}, ';padding:', function (_ref44) {
	  var theme = _ref44.theme;
	  return theme.space[3];
	}, ';background-color:', function (_ref45) {
	  var theme = _ref45.theme;
	  return theme.colors.nearWhite;
	}, ';color:', function (_ref46) {
	  var theme = _ref46.theme;
	  return theme.colors.nearWhite;
	}, ';font-size:', function (_ref47) {
	  var theme = _ref47.theme;
	  return theme.fontSizes[0];
	}, ';font-family:', function (_ref48) {
	  var theme = _ref48.theme;
	  return theme.fonts.monospace;
	}, ';white-space:pre;@media (min-width:', function (_ref49) {
	  var theme = _ref49.theme;
	  return theme.breakpoints[0];
	}, '){font-size:', function (_ref50) {
	  var theme = _ref50.theme;
	  return theme.fontSizes[1];
	}, ';}@media print{background-color:transparent;color:', function (_ref51) {
	  var theme = _ref51.theme;
	  return theme.colors.black;
	}, ';}}img{display:block;width:100%;max-width:48rem;margin-top:', function (_ref52) {
	  var theme = _ref52.theme;
	  return theme.space[4];
	}, ';margin-bottom:', function (_ref53) {
	  var theme = _ref53.theme;
	  return theme.space[4];
	}, ';border-radius:', function (_ref54) {
	  var theme = _ref54.theme;
	  return theme.radii[1];
	}, ';}');
	
	exports.default = MarkdownContent;
	module.exports = exports['default'];

/***/ }),

/***/ 170:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(25);
	
	var _gatsbyImage = __webpack_require__(200);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _MarkdownContent = __webpack_require__(96);
	
	var _MarkdownContent2 = _interopRequireDefault(_MarkdownContent);
	
	var _Layout = __webpack_require__(19);
	
	var _Typography = __webpack_require__(24);
	
	var _SocialLinks = __webpack_require__(65);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ProjectPreview = function ProjectPreview(_ref) {
	  var project = _ref.project,
	      level = _ref.level,
	      props = _objectWithoutProperties(_ref, ['project', 'level']);
	
	  var Content = _MarkdownContent2.default.withComponent('main', {
	    target: 'ed7ifdj0'
	  });
	  var ProjectTitle = _Layout.Text.withComponent(level, {
	    target: 'ed7ifdj1'
	  });
	  var DescriptionComponent = project.frontmatter.description ? _react2.default.createElement(
	    _Layout.Text,
	    { color: 'black' },
	    project.frontmatter.description
	  ) : '';
	  var Image = project.frontmatter.image ? _react2.default.createElement(_gatsbyImage2.default, { sizes: project.frontmatter.image.childImageSharp.sizes }) : '';
	
	  return _react2.default.createElement(
	    _Layout.Box,
	    props,
	    _react2.default.createElement(
	      _Layout.Box,
	      { display: ['block', 'none'], width: 1 / 5 },
	      _react2.default.createElement(
	        _Typography.Paragraph,
	        {
	          fontSize: [2, 3],
	          fontWeight: 7,
	          lineHeight: 'title',
	          mt: 0,
	          mb: 2
	        },
	        project.frontmatter.title,
	        '\xA0',
	        project.frontmatter.repo ? _react2.default.createElement(_SocialLinks.GithubLink, { repo: project.frontmatter.repo }) : '',
	        '\xA0',
	        project.frontmatter.website ? _react2.default.createElement(_SocialLinks.WebsiteLink, { link: project.frontmatter.website }) : ''
	      )
	    ),
	    _react2.default.createElement(
	      _Typography.Paragraph,
	      { fontSize: [2, 3], lineHeight: 'copy', mt: 0, mb: 2 },
	      DescriptionComponent
	    ),
	    _react2.default.createElement(
	      _Typography.Paragraph,
	      { fontSize: [1, 2], lineHeight: 'copy', mt: 3, mb: 2 },
	      Image
	    ),
	    _react2.default.createElement(
	      _Typography.Paragraph,
	      { fontSize: [1, 2], lineHeight: 'copy', mt: 3, mb: 2 },
	      _react2.default.createElement(Content, {
	        lineHeight: 'copy',
	        fontSize: [1, 2],
	        dangerouslySetInnerHTML: { __html: project.html }
	      })
	    )
	  );
	};
	
	exports.default = ProjectPreview;
	module.exports = exports['default'];

/***/ }),

/***/ 454:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(25);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _styledSystem = __webpack_require__(55);
	
	var _gatsbyLink = __webpack_require__(39);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Layout = __webpack_require__(19);
	
	var _Typography = __webpack_require__(24);
	
	var _StyledLink = __webpack_require__(50);
	
	var _SocialLinks = __webpack_require__(65);
	
	var _ProjectPreview = __webpack_require__(170);
	
	var _ProjectPreview2 = _interopRequireDefault(_ProjectPreview);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SectionTitle = _Layout.Text.withComponent('h2', {
	  target: 'egdic2z0'
	});
	
	var indexPage = function indexPage(_ref) {
	  var data = _ref.data;
	
	  return _react2.default.createElement(
	    'article',
	    null,
	    _react2.default.createElement(
	      'header',
	      null,
	      _react2.default.createElement(
	        _Typography.Title,
	        {
	          fontSize: [4, 5],
	          fontWeight: '7',
	          lineHeight: 'title',
	          mt: 0,
	          mb: 3
	        },
	        'Hi!'
	      ),
	      _react2.default.createElement(
	        _Typography.Subtitle,
	        { fontSize: [3, 4], fontWeight: '5', lineHeight: 'title', my: 3 },
	        'I\u2019m Lukas\xA0Pustina.'
	      ),
	      _react2.default.createElement(
	        _Typography.NarrowParagraph,
	        { fontSize: [2, 3], lineHeight: 'copy', mt: 3, mb: 4 },
	        'I\u2019m Chief Information Officer (CIO) and board member at',
	        ' ',
	        _react2.default.createElement(_StyledLink.StyledLink, {
	          to: 'https://scopevisio.com',
	          text: 'Scopevisio',
	          external: true
	        }),
	        ' ',
	        'as well as Managing Director at',
	        ' ',
	        _react2.default.createElement(_StyledLink.StyledLink, {
	          to: 'https://centerdevice.de',
	          text: 'CenterDevice',
	          external: true
	        }),
	        ', where we develop cutting-edge cloud-based software services for enterprises. I\u2019m currently living in Germany.'
	      ),
	      _react2.default.createElement(
	        _Typography.NarrowParagraph,
	        { fontSize: [2, 3], lineHeight: 'copy', mt: 3, mb: 4 },
	        'I\u2019ve enjoyed developing software and building infrastructure for almost 25\xA0years and plan to keep doing so for much longer. In those 25\xA0years, many things have changed drastically. Other things have stayed very much the same. I\u2019ve seen new things become old and old things become new again. In a way, there\'s always something new and something old to learn.'
	      ),
	      _react2.default.createElement(
	        _Typography.NarrowParagraph,
	        { fontSize: [2, 3], lineHeight: 'copy', mt: 3, mb: 4 },
	        'Here you can read my ',
	        _react2.default.createElement(_StyledLink.StyledLink, { to: '/notes/', text: 'Notes' }),
	        ' and ',
	        _react2.default.createElement(_StyledLink.StyledLink, { to: '/publications/', text: 'Publications' }),
	        ' about what I\u2019ve learned, about my',
	        ' ',
	        _react2.default.createElement(_StyledLink.StyledLink, { to: '/projects/', text: 'Projects' }),
	        ', and',
	        ' ',
	        _react2.default.createElement(_StyledLink.StyledLink, { to: '/about/', text: 'About' }),
	        ' me. If you like to talk, you\u2019ll find me on ',
	        _react2.default.createElement(_SocialLinks.SocalLinks, null),
	        '.'
	      )
	    ),
	    _react2.default.createElement('main', null)
	  );
	};
	
	exports.default = indexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-4984e5db9ae51999d851.js